// ClientList.js - Komponente zur Anzeige der Kundenliste
import React from 'react';

/**
 * Komponente zur Anzeige der Kundenliste als Tabelle
 *
 * @param {Object} props - Komponenteneigenschaften 
 * @param {Array} props.clients - Liste der Kunden
 * @param {Function} props.onEditClient - Callback-Funktion beim Klick auf "Edit"
 */
const ClientList = ({ clients, onEditClient }) => {
  return (
    <div className="overflow-x-auto rounded-3xl">
      <table className="min-w-full bg-white shadow-md rounded-lg overflow-hidden">
        <thead>
          <tr>
            <th className="pt-[64px] py-3 px-8 border-b text-left text-[#B2B2B2]">Kundenname</th>
            <th className="pt-[64px] py-3 px-4 border-b text-left text-[#B2B2B2]">Ansprechpartner</th>
            <th className="pt-[64px] py-3 px-4 border-b text-left text-[#B2B2B2]">Hinzugefügt am</th>
            <th className="pt-[64px] py-3 px-8 border-b text-left text-[#B2B2B2]"></th>
          </tr>
        </thead>
        <tbody>
          {clients.map((client) => (
            <tr key={client._id}>
              <td className="pb-[64px] py-3 px-8 border-b font-[700]">
                {client.company.name}
              </td>
              <td className="pb-[64px] py-3 px-4 border-b">
                {client.company.contactPersons?.[0]?.firstName} {client.company.contactPersons?.[0]?.lastName}
              </td>
              <td className="pb-[64px] py-3 px-4 border-b">
                {new Date(parseInt(client._id.substring(0, 8), 16) * 1000).toLocaleDateString()}
              </td>
              <td className="pb-[64px] py-3 px-8 border-b text-[#0000FF] text-right font-[700]">
                <button onClick={() => onEditClient(client)}>Edit</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ClientList;
